import { featureFlagClient } from '@trello/feature-flag-client';

export const isCommentsRewriteEnabled = () => {
  return featureFlagClient.get('aaaa.web.editor', false);
};
